import generic from './generic';
import doublePoints from './double-points';
import jobOpening from './job-opening';
import newRewards from './new-rewards';
import newLeaderboard from './new-leaderboard';
import weekLeftToWin from './week-left-to-win';
import congratulations from './congratulations';
import stats from './stats';

module.exports = [
  generic,
  doublePoints,
  jobOpening,
  newRewards,
  newLeaderboard,
  weekLeftToWin,
  congratulations,
  stats,
];



// WEBPACK FOOTER //
// ./src/emails/index.js